import { put, select, takeEvery } from "redux-saga/effects"
import { axiosPut, del, get, post } from "helpers/api_helper"
import {
  showSavingModal,
  hideSavingModal,
  putMenuItemSuccess,
  setSelectedFeature,
  setIsOutdated,
} from "../actions"
import { getApiErrorMessage, getFormDataFromJSON, showToast } from "utils"
import {
  addDocumentFailed,
  addDocumentSuccess,
  deleteDocumentFailed,
  deleteDocumentSuccess,
  getDocumentFailed,
  getDocumentListFailed,
  getDocumentListSuccess,
  getDocumentSuccess,
  getDocumentsSetupFailed,
  getDocumentsSetupSuccess,
  hideDeleteDocumentModal,
  updateDocumentFailed,
  updateDocumentOrderFailed,
  updateDocumentOrderSuccess,
  updateDocumentStatusFailed,
  updateDocumentStatusSuccess,
  updateDocumentSuccess,
  updateDocumentsSetupFailed,
  updateDocumentsSetupSuccess,
} from "./actions"
import {
  ADD_DOCUMENT,
  DELETE_DOCUMENT,
  GET_DOCUMENT,
  GET_DOCUMENTS_SETUP,
  GET_DOCUMENT_LIST,
  UPDATE_DOCUMENT,
  UPDATE_DOCUMENTS_SETUP,
  UPDATE_DOCUMENT_ORDER,
  UPDATE_DOCUMENT_STATUS,
} from "./actionTypes"

function* addDocument({ payload: params }) {
  try {
    yield put(showSavingModal())
    const response = yield post("/document", getFormDataFromJSON(params))
    if (params.menu_feature === 1) {
      const menuItem = yield axiosPut("/admin/menu-item", {
        entity_id: response.id,
        menu_item_id: response.menu_item_id,
      })
      yield put(putMenuItemSuccess(menuItem))
      yield put(setSelectedFeature(menuItem))
    }
    yield put(addDocumentSuccess(response))
    yield put(setIsOutdated(true))
    yield put(hideSavingModal())
  } catch ({ response }) {
    const message = getApiErrorMessage(response)
    showToast("error", message, "Error")
    yield put(addDocumentFailed(message))
    yield put(hideSavingModal())
  }
}

function* getDocumentList({ payload: { params } }) {
  try {
    const response = yield get("/documents", { params })
    const destroyed = yield select(state => state.Document.listDestroyed)
    if (!destroyed) {
      yield put(getDocumentListSuccess(response))
    }
  } catch (error) {
    yield put(getDocumentListFailed(error))
  }
}

function* getDocument({ payload: params }) {
  try {
    const response = yield get(`/document/${params}`)
    const destroyed = yield select(state => state.Document.destroyed)
    if (!destroyed) {
      yield put(getDocumentSuccess(response))
    }
  } catch ({ response }) {
    const message = getApiErrorMessage(response)
    showToast("error", message, "Error")
    yield put(getDocumentFailed(message))
  }
}

function* deleteDocument({ payload: { featureId, menuItemId } }) {
  try {
    const response = yield del(`/document/${featureId}`, menuItemId)
    yield put(deleteDocumentSuccess(response))
    yield put(hideDeleteDocumentModal())
  } catch (error) {
    yield put(deleteDocumentFailed(error))
  }
}

function* updateDocument({ payload: { featureId, menuItemId, params } }) {
  try {
    yield put(showSavingModal())
    const response = yield post(
      `/document/${featureId}/update`,
      getFormDataFromJSON(params),
      { params: menuItemId }
    )
    yield put(updateDocumentSuccess(response))
    yield put(hideSavingModal())
  } catch ({ response }) {
    const message = getApiErrorMessage(response)
    showToast("error", message, "Error")
    yield put(updateDocumentFailed(message))
    yield put(hideSavingModal())
  }
}

function* updateDocumentOrder({ payload: { featureId, menuItemId, params } }) {
  try {
    const response = yield post(
      `/document/${featureId}/update`,
      getFormDataFromJSON(params),
      { params: menuItemId }
    )
    yield put(updateDocumentOrderSuccess(response))
  } catch (error) {
    yield put(updateDocumentOrderFailed(error))
  }
}

function* updateDocumentStatus({ payload: { featureId, menuItemId, params } }) {
  try {
    const response = yield post(
      `/document/${featureId}/update`,
      getFormDataFromJSON(params),
      { params: menuItemId }
    )
    yield put(setIsOutdated(true))
    yield put(updateDocumentStatusSuccess(response))
  } catch (error) {
    yield put(updateDocumentStatusFailed(error))
  }
}

function* getDocumentsSetup({ payload: params }) {
  try {
    const response = yield get("/documents/setup", { params })
    yield put(getDocumentsSetupSuccess(response))
  } catch (error) {
    yield put(getDocumentsSetupFailed(error))
  }
}

function* updateDocumentsSetup({ payload: params }) {
  try {
    const response = yield post("/admin/documents/setup", params)
    yield put(updateDocumentsSetupSuccess(response))
    showToast("success", "Setup saved", "Success")
  } catch (error) {
    yield put(updateDocumentsSetupFailed(error))
  }
}

function* documentSaga() {
  yield takeEvery(ADD_DOCUMENT, addDocument)
  yield takeEvery(GET_DOCUMENT_LIST, getDocumentList)
  yield takeEvery(GET_DOCUMENT, getDocument)
  yield takeEvery(DELETE_DOCUMENT, deleteDocument)
  yield takeEvery(UPDATE_DOCUMENT, updateDocument)
  yield takeEvery(UPDATE_DOCUMENT_STATUS, updateDocumentStatus)
  yield takeEvery(UPDATE_DOCUMENT_ORDER, updateDocumentOrder)
  yield takeEvery(GET_DOCUMENTS_SETUP, getDocumentsSetup)
  yield takeEvery(UPDATE_DOCUMENTS_SETUP, updateDocumentsSetup)
}

export default documentSaga
